// extracted by mini-css-extract-plugin
export var BuyNowSectionallContainer = "BuyNowSection-module--BuyNowSectionallContainer--fWdJw";
export var BuyNowSectioncardsContainer = "BuyNowSection-module--BuyNowSectioncardsContainer--Pf-SQ";
export var buyNowSection = "BuyNowSection-module--buyNowSection--Dfg6J";
export var buyNowSectionHeader = "BuyNowSection-module--buyNowSectionHeader--6ScFY";